export var InvoicePaymentStatus;
(function (InvoicePaymentStatus) {
    InvoicePaymentStatus["NOT_PAID"] = "not_paid";
    InvoicePaymentStatus["PAST_DUE"] = "past_due";
    InvoicePaymentStatus["PAID"] = "paid";
    InvoicePaymentStatus["VOIDED"] = "voided";
})(InvoicePaymentStatus || (InvoicePaymentStatus = {}));
export const SubscriptionStatus = {
    TRIALING: 'trialing',
    ACTIVE: 'active',
    PAST_DUE: 'past_due',
    UNPAID: 'unpaid',
    CANCELED: 'canceled',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    PAUSED: 'paused',
};
export var ReservedSubscriptionPlanIds;
(function (ReservedSubscriptionPlanIds) {
    ReservedSubscriptionPlanIds[ReservedSubscriptionPlanIds["STARTER"] = 1] = "STARTER";
    ReservedSubscriptionPlanIds[ReservedSubscriptionPlanIds["BUSINESS"] = 2] = "BUSINESS";
    ReservedSubscriptionPlanIds[ReservedSubscriptionPlanIds["CUSTOM"] = 3] = "CUSTOM";
})(ReservedSubscriptionPlanIds || (ReservedSubscriptionPlanIds = {}));
export const recurringIntervals = ['monthly', 'multi-monthly'];
export const STRIPE_MAX_INTERVAL_COUNT = 36;
export var BillingSubscriptionCategory;
(function (BillingSubscriptionCategory) {
    BillingSubscriptionCategory["FREE_TRIAL"] = "Free Trial";
    BillingSubscriptionCategory["STARTER"] = "Starter";
    BillingSubscriptionCategory["BUSINESS"] = "Business";
    BillingSubscriptionCategory["CUSTOM"] = "Custom";
    BillingSubscriptionCategory["CUSTOM_TRIAL"] = "Custom Trial";
    BillingSubscriptionCategory["CUSTOM_AWS"] = "Custom AWS";
    BillingSubscriptionCategory["CUSTOM_PAYGO"] = "Custom PAYGO";
    BillingSubscriptionCategory["CUSTOM_LIST_PRICE"] = "Custom List Price";
    BillingSubscriptionCategory["CUSTOM_PARTNER_ORGANIZATION"] = "Custom Partner Organization";
    BillingSubscriptionCategory["CUSTOM_PLG_LEGACY"] = "Custom PLG Legacy";
})(BillingSubscriptionCategory || (BillingSubscriptionCategory = {}));
export const BillingSubscriptionCustomCategories = [
    BillingSubscriptionCategory.CUSTOM,
    BillingSubscriptionCategory.CUSTOM_TRIAL,
    BillingSubscriptionCategory.CUSTOM_AWS,
    BillingSubscriptionCategory.CUSTOM_PAYGO,
    BillingSubscriptionCategory.CUSTOM_LIST_PRICE,
    BillingSubscriptionCategory.CUSTOM_PARTNER_ORGANIZATION,
    BillingSubscriptionCategory.CUSTOM_PLG_LEGACY,
];
export var BillingSubscriptionType;
(function (BillingSubscriptionType) {
    BillingSubscriptionType["MONTHLY"] = "monthly";
    BillingSubscriptionType["MULTI_MONTHLY"] = "multi-monthly";
})(BillingSubscriptionType || (BillingSubscriptionType = {}));
